import { hpfetch, getHeaders } from '../util';
import { baseUrl } from '../fetch';
import type { cardBubbleType } from '../../types';
import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
  AutocompleteRequest,
  AutocompleteResult,
  SuggestedSearch,
} from '../apiTypes';

export const searchCardsSummaryBubbles = (
  queryString: string,
): Promise<wrappedApiResponseType<Array<cardBubbleType>>> =>
  hpfetch(`cards/summary_bubble/?${queryString}`);

export const searchCards = async (
  queryString: string,
): djangoModelApiResponse<any> => {
  return await hpfetch(`cards/?${queryString}`);
};

export const autocomplete = async (
  req: AutocompleteRequest,
): Promise<AutocompleteResult> => {
  const url = `${baseUrl || ''}cards/autocomplete/?q=${encodeURIComponent(
    req.query,
  )}`;
  const r = await fetch(url, {
    method: 'GET',
    headers: {
      ...getHeaders(),
      'Content-Type': 'application/json',
    },
  });
  const rJson = await r.json();
  const items: Array<SuggestedSearch> = rJson;
  return {
    results: items,
  };
};

export const searchNationwides = (
  mapLocation,
  categoryIds,
  cardTypes,
  searchKeyword = '',
  pageSize,
  offset,
) => {
  const params = new URLSearchParams({
    ordering: 'distance',
    point: `${mapLocation.lng},${mapLocation.lat}`,
    card_categories: categoryIds.join(','),
    card_type: cardTypes,
    nationwide: '1',
    limit: pageSize,
    offset,
  });

  if (searchKeyword) params.set('search', searchKeyword);

  const url = `cards/?${params.toString()}`;
  return hpfetch(url);
};

export const searchCardsCount = (
  queryString: string,
): djangoModelApiResponse<any> => hpfetch(`cards/count/?${queryString}`);

export const searchCardsSummary = (
  queryString: string,
): djangoModelApiResponse<any> => hpfetch(`cards/summary/?${queryString}`);

export const getSingle = (id: string) =>
  hpfetch(`cards/${id}/`, {
    method: 'GET',
  });

export const searchCardsWithPromoted = (
  queryString: string,
): djangoModelApiResponse<any> => hpfetch(`cards/promoted/?${queryString}`);

export const indicateInterest = (uid: string, fields: any) =>
  hpfetch(`cards/${uid}/interest/`, {
    method: 'POST',
    body: JSON.stringify(fields),
  });

export const lookingFor = (
  lookingForText: string,
  location: string,
  searchTerm: string,
): djangoModelApiResponse<any> =>
  hpfetch('cards/looking_for/', {
    method: 'POST',
    body: JSON.stringify({
      looking_for: lookingForText,
      search: {
        location,
        term: searchTerm,
      },
    }),
  });
